<template>
  <div>
    <v-app-bar app fixed dark color="#711610">
      <v-app-bar-nav-icon @click="changeDrawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <span>
        <p v-if="getAdminData" class="text-overline my-auto mx-2">
          Hola, {{ getAdminData.usuario }}
        </p>
        <v-btn v-else icon loading></v-btn>
      </span>

      <v-avatar>
        <img :src="getStaticProfile" />
      </v-avatar>
    </v-app-bar>

    <home-drawer
      v-model="showDrawer"
      @change-drawer="changeDrawer"
      :items="getItemListByAdminType"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'HomeAppBar',

  components: {
    HomeDrawer: () => import('./Drawer')
  },

  data: function () {
    return {
      showDrawer: true,
      toolbarItem: 0,
      navItems: [
        {
          name: 'Dashboard',
          icon: 'mdi-view-dashboard',
          path: '/admin/dashboard'
        },
        {
          name: 'Usuarios UNI',
          icon: 'mdi-school',
          path: '/admin/alumnos'
        },
        {
          name: 'Reclutadores',
          icon: 'mdi-account-tie',
          path: '/admin/reclutadores'
        },
        {
          name: 'Carga Masiva',
          icon: 'mdi-database-arrow-up',
          path: '/admin/carga'
        }
      ]
    };
  },

  computed: {
    getStaticProfile () {
      return require('@/assets/anonymous.png');
    },

    getItemListByAdminType () {
      if (
        this.getAdminData != null &&
        this.getAdminData.adminType === 'MANAGER'
      ) {
        return [
          ...this.navItems,
          {
            name: 'Administradores',
            icon: 'mdi-shield-account',
            path: '/admin/administradores'
          },
          {
            name: 'Noticias',
            icon: 'mdi-newspaper',
            path: '/admin/news'
          }
        ];
      } else {
        return [...this.navItems];
      }
    },

    ...mapGetters('user', ['getError', 'fetching']),
    ...mapGetters('admin', ['getAdminData'])
  },

  methods: {
    changeDrawer () {
      this.showDrawer = !this.showDrawer;
    },

    ...mapActions('user', ['getCarreras'])
  },

  async mounted () {
    await this.getCarreras();
  }
};
</script>
